export function buildScheduleCreateRoute({ customerId, equipmentId } = {}) {
    const query = {};
    if (customerId) query.customer_id = customerId;
    if (customerId && equipmentId) query.equipment_id = equipmentId;
    return { name: "schedule-create", query };
}
